import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import timeFormAPI from '../../api/ui/timeFormAPI';

const CondDateTimePicker = (props) => {
  const { disable, className, value, onChange } = props;

  if (disable) {
    return <>{timeFormAPI.changeDataLog(value)}</>;
  }

  const handleDateTimeChange = (e) => {
    const newDateTime = e.target.value;
    if (newDateTime) {
      // HTML datetime-local input의 값을 moment 객체로 변환
      const momentDate = moment(newDateTime);
      onChange(momentDate);
    }
  };

  // value를 "YYYY-MM-DDTHH:mm" 형식으로 변환
  const inputValue = value ? moment(value).format('YYYY-MM-DDTHH:mm') : '';

  return (
    <input
      type="datetime-local"
      className={className}
      value={inputValue}
      onChange={handleDateTimeChange}
      style={{ maxHeight: 32, width: 'fit-content' }}
    />
  );
};

CondDateTimePicker.propTypes = {
  disable: PropTypes.bool.isRequired,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
};

export default CondDateTimePicker;
